import type { ComponentProps } from "react";

export function BandTextButton(props: ComponentProps<"button">) {
    return (
        <button
            type="button"
            className="mt-2 inline-flex min-h-11 cursor-pointer items-center rounded-nested text-body-small font-semibold text-doberman-black underline decoration-doberman-black/20 underline-offset-3 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow [@media(hover:hover)]:hover:decoration-doberman-black"
            {...props}
        />
    );
}
